import { Box, Divider, Grid2, Paper, Typography } from "@mui/material"
import { CalculationType, ExaminationConfig } from "graphql/types"

interface ExaminationConfigDetailPanelProps {
  row: ExaminationConfig
}

const ExaminationConfigDetailPanel = ({ row }: ExaminationConfigDetailPanelProps) => {
  return (
    <Box sx={{ p: 3, ml: 5 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          {row.name}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid2 container spacing={3}>
          {row.laboratory && (
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2">Laborbereich</Typography>
                <Typography variant="body1">{row.laboratory.name}</Typography>
              </Box>
            </Grid2>
          )}
          <Grid2 size={{ xs: 12, md: 6 }}>
            {row.skill && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2">Qualifikation</Typography>
                <Typography variant="body1">{row.skill.name}</Typography>
              </Box>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="body2">Berechnungstyp</Typography>
              <Typography variant="body1">
                {row.defaultCalculation.calculationType === CalculationType.TIME
                  ? "Zeit"
                  : "Verbindung"}
              </Typography>
            </Box>
          </Grid2>

          {/* EUT Eigenschaftsgruppen */}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography variant="body2">EUT Eigenschaftsgruppen</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {row.eutDataGroups.length > 0 ? (
                row.eutDataGroups.map((group) => (
                  <Typography key={group.id}>{group.name}</Typography>
                ))
              ) : (
                <Typography variant="body2">Keine EUT Eigenschaftsgruppen vorhanden</Typography>
              )}
            </Box>
          </Grid2>
          {/* Arbeitsgänge */}
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Typography variant="body2">Arbeitsgänge</Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {row.tasks.length > 0 ? (
                row.tasks.map((task) => <Typography key={task.id}>{task.name}</Typography>)
              ) : (
                <Typography variant="body2">Keine Aufgaben vorhanden</Typography>
              )}
            </Box>
          </Grid2>
        </Grid2>
      </Paper>
    </Box>
  )
}

export default ExaminationConfigDetailPanel
